<template>
  <div class="wrapper">
    <div class="head">
      <div class="head-left">
        <div class="user-pic" ref="userPic"></div>
        <div class="user-name">
          用户名：
          <span>{{username}}</span>
        </div>
      </div>
      <div class="user-menu">
        <div class="user-btn" @click="logout">退出账户</div>
      </div>
    </div>
    <ul class="content">
      <li>
        <span class="til">真实姓名</span>
        <input type="text" v-model="realname" />
      </li>
      <li>
        <span class="til">医院名称</span>
        <input type="text" v-model="unit" />
      </li>
      <li>
        <div class="saveBtn" v-show="isShowSaveInfo" @click="saveProfile">保存</div>
      </li>
      <li>
        <div class="saveBtn disabled" v-show="!isShowSaveInfo">保存</div>
      </li>
    </ul>

    <ul class="content">
      <li style="margin-bottom: 18px; ">
        <span class="til" style="width: 240px;font-size: 15px;color: #49a2c2;">存储空间使用概况 (团队整体):</span>
      </li>

      <div class="storage-card">
        <!-- 卡片标题 -->
        <!-- <div class="storage-title">
          <i class="el-icon-folder-opened"></i>
          <span>存储空间使用概况</span>
        </div> -->

        <!-- 核心数据展示 -->
        <div class="storage-info">
          <div class="info-item">
            <label>总分配空间：</label>
            <span class="num">{{ accountInfo.space_allocated ? spaceAllocated : '--/--' }} GB</span>
          </div>
          <div class="info-item">
            <label>已使用空间：</label>
            <span class="num use">{{ accountInfo.space_used ? spaceUsed : '--/--' }} GB</span>
          </div>
          <div class="info-item">
            <label>剩余可用空间：</label>
            <span class="num free">{{ freeSize}} GB</span>
          </div>
          <div class="info-item">
            <label>使用率：</label>
            <span class="num rate">{{ usageRate }}%</span>
          </div>
        </div>

        <!-- 进度条可视化 -->
        <div class="progress-box">
          <el-progress
            :percentage="usageRate"
            :color="progressColor"
            :stroke-width="20"
            text-inside
          ></el-progress>
        </div>

        <!-- 提示文案 -->
        <div class="tip-text" :class="tipClass">
          {{ tipText }}
        </div>
      </div>
    </ul>


    <ul class="content">
      <li style="margin-bottom: 18px;">
        <span class="til" style="width: 80px;font-size: 15px;color: #49a2c2;">修改手机号:</span>
      </li>
      <li>
        <span class="til">手机号码</span>
        <input type="text" v-model="phoneNum" />
        <span class="get-code" v-show="isShowGetCodeBtn" @click="getCode">获取验证码</span>
        <span class="get-code disabled" v-show="isShowGetCodeBtnDisabled">获取验证码</span>
        <span class="count-down" v-show="isShowCountDown">{{countDown}}</span>
      </li>
      <li>
        <span class="til">验证码</span>
        <input type="text" v-model="code" />
      </li>
      <li>
        <span class="til">登录密码</span>
        <input type="password" v-model="password" />
      </li>
      <li>
        <div class="saveBtn" v-show="isShowSavePhone" @click="savePhonNum">保存</div>
      </li>
      <li>
        <div class="saveBtn disabled" v-show="!isShowSavePhone">保存</div>
      </li>
    </ul>
    <ul class="content">
      <li style="margin-bottom: 18px;">
        <span class="til" style="width: 70px;font-size: 15px;color: #49a2c2;">修改密码:</span>
      </li>
      <li>
        <span class="til">原密码</span>
        <input type="password" v-model="oldPassword" />
      </li>
      <li>
        <span class="til">新密码</span>
        <input type="password" v-model="newPassword" />
      </li>
      <li>
        <span class="til">新密码</span>
        <input type="password" v-model="newPasswordAgain" />
      </li>
      <li>
        <div class="saveBtn" v-show="isShowSavePassword" @click="savePassword">保存</div>
      </li>
      <li>
        <div class="saveBtn disabled" v-show="!isShowSavePassword">保存</div>
      </li>
    </ul>
    <ul class="content report_title_new">
      <div style="width:50%">
        <li>
          <span class="til">报告抬头1:(纯文本形式)</span>
          <input type="text" v-model="report" />
        </li>
        <li>
          <div class="saveBtn" v-show="isShowReport" @click="saveProfile">保存</div>
        </li>
        <li>
          <div class="saveBtn disabled" v-show="!isShowReport">保存</div>
        </li>
      </div>
      <div style="width:50%" class="report-icon">
        <li>
        <span class="til label">报告抬头2：（图片形式）</span>
        <div class="icon-box" @click="addReportIcon">
          <input
            ref="reportIconInput"
            class="reportIconInput"
            type="file"
            placeholder
            @change.stop="selectReportIcon"
            accept="image/*"
          />
          <div class="icon-image" v-if="reportLogo?true:false">
            <img :src="reportLogo" alt class="reportLogo" />
          </div>
          <div class="add-icon iconfont" v-else>&#xe600;</div>
        </div>
      </li>
      <li>
        <div class="saveBtn disabled" @click="addReportIcon" v-show="!isShowSavePassword">选择照片</div>
      </li>
      </div>
      
    </ul>
    <ul class="content report-icon">
      <li>
         <span class="til label">报告影像板式</span>
 
      </li>
      <li style="margin:30px 50px">
         <el-radio v-model="radioModel" label="1"> 两张影像一行排列</el-radio>
        <el-radio v-model="radioModel" label="2"> 三张影像一行排列</el-radio>
      </li>
    </ul>
    <ul class="content report-icon" v-if="false">
      <li>
        <span class="til label">报告抬头2：（图片形式）</span>
        <div class="icon-box" @click="addReportIcon">
          <input
            ref="reportIconInput"
            class="reportIconInput"
            type="file"
            placeholder
            @change.stop="selectReportIcon"
            accept="image/*"
          />
          <div class="icon-image" v-if="reportLogo?true:false">
            <img :src="reportLogo" alt class="reportLogo" />
          </div>
          <div class="add-icon iconfont" v-else>&#xe600;</div>
        </div>
      </li>
      <li>
        <div class="saveBtn disabled" @click="addReportIcon" v-show="!isShowSavePassword">选择照片</div>
      </li>
      <!-- <li>
        <div class="saveBtn disabled" @click="removeReportIcon" v-show="reportLogo">删除照片</div>
      </li> -->
      <li style="fontSize:10px;color:red">注： </li>
      <li class="waringText" style="fontSize:10px;color:red">1.建议采用医院图标+医院名称的图片内容格式。 </li>
      <li class="waringText" style="fontSize:10px;color:red"> 2.建议上传png/jpg/jpeg图片格式。 </li>
      <li class="waringText" style="fontSize:10px;color:red"> 3.当上传图片后，将自动采取图片形式作为报告抬头打印</li>
    </ul>
  </div>
</template>

<script>
import gql from "graphql-tag";
import api from "../api";

export default {
  name: "",
  data() {
    return {
      username: "",
      realname: "",
      user: {
        phone: "",
        realname: "",
        unit: "",
        report: "",
        leader_id: ""
      },
      phoneNum: "",
      unit: "",
      code: "",
      radioModel:"",
      password: "",
      countDown: "60秒后重新获取",
      isShowGetCodeBtn: false,
      isShowGetCodeBtnDisabled: true,
      isShowCodeInput: false,
      isShowCountDown: false,
      isShowSavePhone: false,
      isShowPasswordInput: false,
      isShowSaveInfo: false,
      isShowReport: false,
      isShowSavePassword: false,
      oldPassword: "",
      newPassword: "",
      newPasswordAgain: "",
      timer: null,
      report: "",
      radio: '1',
      reportLogo: "",
      doctorheader: api.doctor_header,
      // 账户信息
      accountInfo: {},

    };
  },

  computed: {
    spaceAllocated(){
      if(this.accountInfo.space_allocated>0){
        return parseFloat((this.accountInfo.space_allocated/1000).toFixed(2));
      }else{
        return '--/--';
      }
    },
    spaceUsed(){
      if(this.accountInfo.space_used>0){
        return parseFloat((this.accountInfo.space_used/1000).toFixed(2));
      }else{
        return '--/--';
      }
    },
    // 剩余空间
    freeSize() {
      if(this.accountInfo.space_allocated &&this.accountInfo.space_used){
        return parseFloat(((this.accountInfo.space_allocated - this.accountInfo.space_used)/1000).toFixed(2));
      }else{
        return '--/--';
      }
      
    },
    // 使用率 百分比
    usageRate() {
      if (this.accountInfo.space_allocated <= 0) return 0;
      let rate = (this.accountInfo.space_used / this.accountInfo.space_allocated) * 100;
      return Math.min(parseFloat(rate.toFixed(1)), 100);
    },
    // 进度条颜色：绿色正常 / 橙色预警 / 红色危险
    progressColor() {
      const rate = this.usageRate;
      if (rate < 80) return "#67C23A"; // 绿色
      if (rate < 90) return "#E6A23C"; // 橙色
      return "#F56C6C"; // 红色
    },
    // 提示文案+样式
    tipText() {
      const rate = this.usageRate;
      if (rate < 80) return "存储空间充足，请正常使用";
      if (rate < 90) return "存储空间即将不足，建议尽快升级扩容！";
      return "存储空间严重不足，请尽快升级扩容！";
    },
    tipClass() {
      const rate = this.usageRate;
      if (rate < 80) return "tip-success";
      if (rate < 90) return "tip-warning";
      return "tip-danger";
    }
  },

  methods: {
    // removeReportIcon(){
    //   this.saveHospitalLogo('','','')
    // },
    // 添加报告图片
    addReportIcon() {
      this.$refs.reportIconInput.click();
    },
    // 选择报告图标
    async selectReportIcon(e) {
      // 如果没有选中文件就return
      if (!e.target.files.length) {
        e.target.value = '';
        return;
      }
      let filesName = e.target.files[0];
      let reader = new FileReader();
      let imgObjArr;
      let ext = "jpg";
      let imgData;
      await new Promise((resolve, reject) => {
        reader.readAsDataURL(filesName);
        reader.onload = event => {
          imgData = event.target.result;

          imgObjArr = event.target.result.replace(
            /^data:image\/(jpeg|png);base64,/,
            ""
          );
          resolve();
        };
      });
      await this.saveHospitalLogo(imgObjArr, ext, imgData);
      e.target.value = '';
    },
    async saveHospitalLogo(data, ext, imgData) {
      try {
        const a = await this.$apollo.mutate({
          mutation: gql`
            mutation($logoBase64: String!, $logoExt: String!) {
              doctorSaveHospitalLogo(logoBase64: $logoBase64, logoExt: $logoExt)
            }
          `,
          variables: {
            logoBase64: data,
            logoExt: ext
          }
        });
        this.reportLogo = imgData;
        this.$message.success("数据已保存");
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async getCode() {
      this.isShowGetCodeBtnDisabled = false;
      const reg = /^1\d{10}$/;
      if (!reg.test(this.phoneNum)) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      this.isShowCodeInput = true;
      this.isShowCountDown = true;
      this.isShowGetCodeBtn = false;
      this.isShowSavePhone = true;
      this.isShowPasswordInput = true;
      if (this.countDown !== '60秒后重新获取') {
        return
      }
      // 倒计时
      let countDownNum = 59;
      this.timer = setInterval(() => {
        if (countDownNum <= -1) {
          this.isShowCountDown = false;
          this.isShowGetCodeBtn = (this.user.phone !== this.phoneNum) ? true : false;
          this.isShowGetCodeBtnDisabled = (this.user.phone !== this.phoneNum) ? false : true;
          countDownNum = 59;
          this.countDown = '60秒后重新获取';
          clearInterval(this.timer);
          return
        }
        this.countDown = countDownNum + '秒后重新获取';
        countDownNum--;
      }, 1000);
      // 验证码请求
      try {
        const a = await this.$apollo.mutate({
          mutation: gql`mutation($phone: String!) {
                        sendVCode(phone: $phone)
                    }`,
          variables: {
            phone: this.phoneNum
          }
        });
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async savePhonNum() {
      const reg = /^1\d{10}$/;
      if (!reg.test(this.phoneNum)) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      if (this.code === "") {
        this.$message.error("请输入验证码");
        return;
      }
      if (this.password === "") {
        this.$message.error("请输入密码");
        return;
      }
      try {
        let ph = await this.$apollo.mutate({
          mutation: gql`
            mutation($password: String!, $phone: String!, $vcode: String!) {
              doctorModifyPhone(
                password: $password
                phone: $phone
                vcode: $vcode
              )
            }
          `,
          variables: {
            password: this.password,
            phone: this.phoneNum,
            vcode: this.code
          }
        });
        this.$message({
          message: "保存成功",
          type: "success"
        });
        // 重置状态
        this.isShowGetCodeBtn = false;
        this.isShowCountDown = false;
        this.isShowSavePhone = false;
        this.isShowGetCodeBtnDisabled = true;
        this.code = "";
        this.password = "";
        this.user.phone = this.phoneNum;
        this.countDown = "60秒后重新获取";
        clearInterval(this.timer);
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async savePassword() {
      const newPassword = this.newPassword;
      if (
        this.oldPassword !== "" &&
        newPassword !== "" &&
        this.newPasswordAgain !== ""
      ) {
        const reg1 = /\d/;
        const reg2 = /[a-zA-Z]/;
        if (newPassword !== this.newPasswordAgain) {
          this.$message.error("新密码输入不相同");
        } else if (newPassword.length < 6 || newPassword.length > 16) {
          this.$message.error("密码长度要6到16位之间");
        } else if (!reg1.test(newPassword) || !reg2.test(newPassword)) {
          this.$message.error("需包含至少一个字母和一个数字");
        } else {
          try {
            await this.$apollo.mutate({
              mutation: gql`
                mutation($password: String!, $newPassword: String!) {
                  doctorModifyPassword(
                    password: $password
                    newPassword: $newPassword
                  )
                }
              `,
              variables: {
                password: this.oldPassword,
                newPassword
              }
            });
            this.$message({
              message: "修改成功",
              type: "success"
            });
            this.isShowSavePassword = false;
          } catch (e) {
            this.$message.error(error.message.split(":")[1]);
          }
        }
      } else {
        this.$message.error("密码不能为空");
      }
    },
    async saveProfile() {
      try {
        let realname = this.realname;
        let unit = this.unit;
        let report = this.report;
        let a = await this.$apollo.mutate({
          mutation: gql`mutation{
                        doctorModifyProfile(realname: "${realname}", unit: "${unit}", report_title: "${report}"){
                            id
                        }
                    }`
        });
        this.$message({
          message: "保存成功",
          type: "success"
        });
        this.isShowSaveInfo = false;
        this.isShowReport = false;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
     async saveReportModel() {
      try {
        let reporttype = Number(this.radioModel)
        await this.$apollo.mutate({
          mutation: gql`mutation{
                        doctorModifyProfile(print_type: ${reporttype}){
                            id
                        }
                    }`
        });
        this.$message({
          message: "修改成功",
          type: "success"
        });
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async logout() {
      try {
        const res = await this.$apollo.mutate({
          mutation: gql`
            mutation {
              doctorLogout
            }
          `
        });
        if (res.data) {
          // 断开EventSource连接
          if (window.eventSrc) {
            window.eventSrc.close();
          }
          this.$store.commit('controller/sethasLogin', true);
          this.$store.commit('controller/setintellModel', []);
          this.$store.commit('controller/setauths', ['diagnoses_image']);
          this.$store.commit('controller/seteditDuration', 7*24*3600*1000);
          this.$router.push("/login");
          this.$message({
            message: "退出成功",
            type: "success"
          });
          
          window.sessionStorage.clear();
        }
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async getAccountInfo(leader_id){
      // let doctor_id = this.$store.state.doctorId
      // console.log("In getAccountInfo, doctor_id:",doctor_id)
      if (leader_id) {
        const res = await this.$apollo.query({
          query: gql`
            query($doctor_id: Int) {
              accountInfo(doctor_id: $doctor_id){
                  id
                  doctor_id
                  user_type
                  account_type
                  trial_start_date
                  trial_end_date
                  trial_months
                  vip_start_date
                  vip_expire_date
                  status 
                  message
                  space_used
                  space_allocated
                  operation_time
              }
          }`,
          variables: {
            doctor_id: leader_id
          },  
          fetchPolicy: "no-cache"
        });
        let accountInfo = res.data.accountInfo;
        accountInfo.operation_time = accountInfo.operation_time ? new Date(accountInfo.operation_time) : null;
        console.log("In getAccountInfo, accountInfo:", accountInfo);
        return accountInfo        
        // 即使数据库无记录，返回数据为 {id: null, doctor_id: null, user_type: null, account_type: null, trial_start_date: null...}
        // if(accountInfo!==null && accountInfo.doctor_id!==null){
        //   this.$store.commit("setAccountInfo", JSON.stringify(accountInfo));
        //   console.log("In getAccountInfo, test get accountInfo from store.state:",JSON.parse(this.$store.state.accountInfo));
        // }else{
        //   this.$store.commit("setAccountInfo", "");
        // }
      }
    }
  },
  async mounted() {
    try {
      const usernameRes = await this.$apollo.query({
        query: gql`
          {
            me {
              username
              realname
              leader_id
              unit
              phone
              avatar
              report_title
              hospital_logo
              print_type
            }
          }
        `,
        fetchPolicy: "no-cache"
      });
      console.log(usernameRes.data.me)
      this.radioModel = usernameRes.data.me.print_type.toString()
      this.username = usernameRes.data.me.username;
      this.realname = usernameRes.data.me.realname;
      this.unit = usernameRes.data.me.unit;
      this.report = usernameRes.data.me.report_title;
      this.phoneNum = usernameRes.data.me.phone;
      this.user.phone = usernameRes.data.me.phone;
      this.user.realname = usernameRes.data.me.realname;
      this.user.report = usernameRes.data.me.report_title;
      this.user.unit = usernameRes.data.me.unit;
      this.user.leader_id = usernameRes.data.me.leader_id;
      if (usernameRes.data.me.avatar !== "") {
        this.$refs.userPic.style.backgroundImage = `url(${api.doctor_header +
          usernameRes.data.me.avatar})`;
      }
      if (usernameRes.data.me.hospital_logo) {
        this.reportLogo = api.doctor_header + usernameRes.data.me.hospital_logo;
      }
      // 获取用户账户信息，包括套餐类型，日期，当前存储空间使用情况等
      this.accountInfo = await this.getAccountInfo(usernameRes.data.me.leader_id);
      console.log("In userAccount.vue, mounted, get accountInfo:", this.accountInfo);
    } catch (error) {
      this.$message.error(error.message.split(":")[1]);
    }
  },
  watch: {
    async radioModel(newVal,oldVal){
      if(newVal&&oldVal){
        await this.saveReportModel()
      }
    },
    phoneNum(val) {
      if (this.countDown !== "60秒后重新获取") {
        return;
      }
      this.isShowGetCodeBtn = this.user.phone !== val ? true : false;
      this.isShowGetCodeBtnDisabled = this.user.phone !== val ? false : true;
      this.isShowCountDown = false;
    },
    realname(val) {
      if (this.user.realname !== val) {
        this.isShowSaveInfo = true;
      }
    },
    unit(val) {
      if (this.user.unit !== val) {
        this.isShowSaveInfo = true;
      }
    },
    oldPassword() {
      this.isShowSavePassword = true;
    },
    newPassword() {
      this.isShowSavePassword = true;
    },
    newPasswordAgain() {
      this.isShowSavePassword = true;
    },
    report(val) {
      if (this.user.report !== val) {
        this.isShowReport = true;
      }
    }
  }
};
</script>

<style lang='less' scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .report_title_new{
    display: flex;

  }

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 200px;

    .head-left {
      margin-left: 20px;
    }

    .user-pic {
      float: left;
      width: 150px;
      height: 150px;
      border: 2px solid #8cc3d5;
      background-size: 150px 150px;
      background-color: azure;
    }

    .user-name {
      float: left;
      height: 24px;
      margin-top: 126px;
      margin-left: 10px;
      font-weight: bold;
      font-size: 20px;
    }

    .user-menu {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      float: right;
      width: 100px;
      height: 150px;

      .user-btn {
        float: left;
        width: 80px;
        height: 25px;
        color: #fff;
        border-radius: 5px;
        background-color: #49a2c2;
        text-align: center;
        line-height: 25px;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
      }
    }
  }

  .content {
    padding: 20px;
    border-top: 2px solid #8cc3d5;

    li {
      margin-bottom: 10px;

      .til {
        display: inline-block;
        width: 60px;
        font-size: 14px;
        font-weight: bold;
      }

      input {
        width: 300px;
        height: 30px;
        border-radius: 5px;
        margin-left: 50px;
        border: 1px solid #bbb;
        outline: none;
        text-indent: 10px;
      }

      .saveBtn {
        width: 80px;
        height: 20px;
        border-radius: 5px;
        color: #fff;
        background-color: #49a2c2;
        user-select: none;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
        line-height: 20px;
      }

      .saveBtn.disabled {
        background-color: #bbb;
        cursor: default;
      }

      .get-code {
        font-size: 14px;
        color: #fff;
        padding: 6px 4px;
        border-radius: 5px;
        margin-left: 20px;
        background-color: #49a2c2;
        cursor: pointer;
      }

      .get-code.disabled {
        background-color: #bbb;
        cursor: default;
      }

      .count-down {
        font-size: 14px;
        color: #fff;
        padding: 6px 4px;
        border-radius: 5px;
        margin-left: 20px;
        background-color: #49a2c2;
        user-select: none;
      }
    }
  }

  .report-icon li {
    display: flex;
    .label {
      width: 90px;
    }
    .icon-box {
      position: relative;
      width: 100px;
      height: 100px;
      margin-left: 20px;
      user-select: none;
      cursor: pointer;
      .reportIconInput {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        border: 0;
        margin: 0;
      }
      .add-icon {
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0;
        color: #ccc;
        width: 100%;
        height: 100%;
        font-size: 111px;
        margin: 0;
      }
      .icon-image {
        position: absolute;
        left: 0;
        top: 0;
        width: 350px;
        height: 100%;
        background-color: #ebebeb;
        border: 1px solid #ccc;
        display: flex;
        align-items: center;
        overflow-y: auto;
      }
    }
  }
}
.reportLogo {
  width: 100%;
  height: auto;
}
.waringText{
  text-indent: 2em;
}


// 存储空间使用情况专用 START
.storage-card {
  width: 100%;
  max-width: 600px;
  // padding: 20px;
  // background: #fff;
  // border-radius: 8px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
}
.storage-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.storage-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 24px;
}
.info-item {
  font-size: 14px;
  color: #606266;
}
.info-item .num {
  font-weight: bold;
  margin-left: 6px;
}
.info-item .use {
  color: #F56C6C;
}
.info-item .free {
  color: #67C23A;
}
.info-item .rate {
  color: #409EFF;
}
.progress-box {
  margin-bottom: 16px;
}
.tip-text {
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 4px;
}
.tip-success {
  background: #f0f9e8;
  color: #67C23A;
}
.tip-warning {
  background: #fdf6ec;
  color: #E6A23C;
}
.tip-danger {
  background: #fef0f0;
  color: #F56C6C;
}
// 存储空间使用情况END

</style>
